// extracted by mini-css-extract-plugin
module.exports = {"img":"CommunityProfImg_img__2fu85","hoverImg":"CommunityProfImg_hoverImg__PW_W0","loadingImg":"CommunityProfImg_loadingImg__1fTcE"};